import gql from 'graphql-tag';

const EDIT_USER_SELF = gql`
  mutation updateUser($avatar: MediaUpdateOneWithoutUsersInput, $id: ID!, $timezone: String) {
    updateUser(where: { id: $id }, data: { avatar: $avatar, timezone: $timezone }) {
      id
      avatar {
        id
        key
      }
      timezone
    }
  }
`;

export default EDIT_USER_SELF;
